import { Link, To } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import { ButtonProps } from '@dbt-labs/sourdough';

type NavButtonParams<TOption extends string> = {
  id: TOption;
  to: To;
  isSelected: boolean;
} & ButtonProps;

export const NavButton = <TOption extends string>({
  id,
  to,
  children,
  className,
  isSelected,
  isDisabled,
  testId = `nav-button-${id}`,
  ...buttonProps
}: NavButtonParams<TOption>) => {
  // TODO: migrate this to a sourdough link after resolving prop issues
  const noopNavigate = { onClick: (event: any) => event.preventDefault() };
  return (
    <Link
      data-testid={testId}
      {...buttonProps}
      className={twMerge(
        className,
        'duration-200 hover:bg-bgMainHover motion-reduce:duration-0',
        isSelected && 'bg-bgBrandMuted text-fgMain',
        isSelected &&
          'prodEnv:bg-bgInfoMuted stagingEnv:bg-bgSuccessMuted devEnv:bg-bgInfoAltMuted',
        !isSelected && 'bg-transparent text-fgMain',
      )}
      to={to}
      {...(isDisabled ? noopNavigate : {})}
    >
      {children}
    </Link>
  );
};
